import styled from 'styled-components';

export const Overlay = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.66);
  z-index: 2000;
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
`;

export const ModalShell = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const ModalCard = styled.div<{ $bg: string; $color: string }>`
  border-radius: 4px;
  padding: 34px 26px 24px;
  width: 380px;
  position: relative;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.55);
  transform: rotate(-0.7deg);
  font-family: var(--body);
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
`;

export const MNav = styled.button<{ $side: 'prev' | 'next'; $avail: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ $side }) => ($side === 'prev' ? 'left: -54px;' : 'right: -54px;')}
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: #fff;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  opacity: ${({ $avail }) => ($avail ? 1 : 0)};
  pointer-events: ${({ $avail }) => ($avail ? 'auto' : 'none')};
  transition:
    opacity 0.2s ease,
    background 0.15s,
    transform 0.15s;
  z-index: 5;

  &:hover {
    ${({ $avail }) =>
      $avail &&
      `
        background: rgba(255,255,255,.28);
        transform: translateY(-50%) scale(1.07);
      `}
  }
`;

export const Magnet = styled.div<{ $color: string; $accent: string }>`
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  z-index: 4;
  background: radial-gradient(
    circle at 35% 30%,
    #fff,
    ${({ $color }) => $color} 45%,
    ${({ $accent }) => $accent} 100%
  );
  box-shadow:
    0 3px 7px rgba(0, 0, 0, 0.45),
    inset 0 1px 2px rgba(255, 255, 255, 0.85),
    inset 0 -2px 4px rgba(0, 0, 0, 0.4);
`;

export const DeckPos = styled.div<{ $color: string }>`
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  margin: -4px 0 12px;
  opacity: 0.65;
  color: ${({ $color }) => $color};
`;

export const QLbl = styled.div<{ $color: string }>`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 6px;
  color: ${({ $color }) => $color};
`;

export const QText = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 14px;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const Stars = styled.div<{ $color: string }>`
  display: flex;
  font-size: 20px;
  letter-spacing: 2px;
  margin-bottom: 6px;
  color: ${({ $color }) => $color};
`;

export const StarWrap = styled.span`
  position: relative;
  display: inline-flex;
`;

export const StarHalf = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  overflow: hidden;
`;

export const DraftNote = styled.span<{ $color: string }>`
  font-size: 13px;
  font-style: italic;
  color: ${({ $color }) => $color};
`;

export const StarsQuestion = styled.div<{ $color: string }>`
  font-size: 11.5px;
  font-style: italic;
  margin-bottom: 14px;
  color: ${({ $color }) => $color};
`;

export const Badges = styled.div`
  margin-bottom: 14px;
  display: flex;
  flex-wrap: wrap;
`;

export const NoValuesNote = styled.span<{ $color: string }>`
  font-size: 11px;
  color: ${({ $color }) => $color};
  font-style: italic;
`;

export const Meta = styled.div<{ $color: string }>`
  font-size: 11px;
  margin-bottom: 16px;
  font-weight: 600;
  color: ${({ $color }) => $color};
`;

export const MetaStrong = styled.strong<{ $color: string }>`
  color: ${({ $color }) => $color};
  letter-spacing: 0.5px;
`;

export const Divider = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.16);
  padding-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MBtn = styled.button<{ $variant: 'wb' | 'del' | 'cls' }>`
  border: none;
  border-radius: 7px;
  padding: 12px 0;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: var(--body);
  width: 100%;

  ${({ $variant }) => {
    switch ($variant) {
      case 'wb':
        return 'background: #1e2a26; color: #bfe3c8;';
      case 'del':
        return 'background: #5a1e1e; color: #f5c0c0;';
      case 'cls':
      default:
        return 'background: rgba(0,0,0,.1); color: #333; font-weight: 600; font-size: 13px;';
    }
  }}
`;

export const Pen = styled.span`
  display: inline-block;
  transform: scaleX(-1);
`;
